import { LoadingButton } from '@mui/lab';
import { Alert, Box, Grid, Paper, TextField, Typography } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { BLUE_COLOR, WHITE_COLOR } from '../../../constants/ColorsConst';
import { EMAIL, REMEMBER_ME } from '../../../constants/ConfigConst';
import { logoColor, splash } from '../../../helpers/ImagesUtils';
import { LOGOUT } from '../../../store/Types';
import { mdTheme } from '../../../widgets/template';
import CopyrightTemplate from '../../../widgets/template/Copyright';
import { loginAction } from './LoginAction';
import PasswordField from './components/PasswordField';

const LoginModule = () => {
  const dispatch = useDispatch();
  let history = useHistory();

  const [dataLogin, setDataLogin] = React.useState({
    user: '',
    password: '',
    isRemember: false,
  });
  const [userError, setUserError] = React.useState(false);
  const [passwordError, setPasswordError] = React.useState(false);

  const [showPassword, setShowPassword] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [errorLogin, setErrorLogin] = React.useState(null);

  // eslint-disable-next-line no-unused-vars
  const [num, setNum] = React.useState(Math.floor(Math.random() * 19) + 1);

  React.useEffect(() => {
    dispatch({
      type: LOGOUT,
    });
    const userLocal = localStorage.getItem(EMAIL);
    const rememberMeLocal = localStorage.getItem(REMEMBER_ME);
    const x = {
      user: userLocal,
      isRemember: rememberMeLocal === '1',
    };
    setDataLogin({ ...dataLogin, ...x });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleSetData = (prop, check) => (event) => {
    setDataLogin({
      ...dataLogin,
      [prop]: check ? event.target.checked : event.target.value,
    });
  };

  const _handleSubmit = async (event) => {
    event.preventDefault();

    let validUser = dataLogin.user === '';
    let validPaswword = dataLogin.password === '';

    setUserError(validUser);
    setPasswordError(validPaswword);

    if (!validUser && !validPaswword) {
      setLoading(true);
      const res = await loginAction({ dispatch, history, dataLogin });
      setErrorLogin(res);
      setLoading(false);
    }
  };

  const form = (
    <>
      <Box
        sx={{
          mt: 8,
          mx: 6,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          height: '87%',
        }}
        autoComplete="off"
      >
        <img alt="OnEDU" src={logoColor} width="200" style={{ zIndex: 100 }} />
        <Typography sx={{ zIndex: 100 }} align="center">
          Más que una escuela,
          <br />
          un aliado en tu camino hacia el éxito.
        </Typography>
        <Typography
          sx={{
            mt: 3,
            zIndex: 100,
          }}
          align="center"
          component="h1"
          variant="h5"
        >
          Inicio de Sesión
        </Typography>
        <Box
          component="form"
          noValidate
          onSubmit={_handleSubmit}
          sx={{
            mt: 1,
            mx: 5,
          }}
        >
          {!errorLogin ? null : (
            <Alert
              severity="error"
              sx={{ mb: 2 }}
              onClick={() => {
                setErrorLogin(null);
              }}
            >
              {errorLogin}
            </Alert>
          )}
          <TextField
            required
            fullWidth
            id="user"
            label="Usuario"
            name="user"
            value={dataLogin.user}
            autoComplete="user"
            onChange={_handleSetData('user', false)}
            autoFocus
            error={userError}
            sx={{ mb: 2 }}
          />
          <PasswordField
            value={dataLogin.password}
            error={passwordError}
            onClick={() => {
              setShowPassword(!showPassword);
            }}
            showPassword={showPassword}
            onChange={_handleSetData('password', false)}
          />
          {/* <FormControlLabel
                        control={<Checkbox
                            checked={dataLogin.isRemember}
                            onChange={_handleSetData('isRemember', true)}
                            inputProps={{ 'aria-label': 'controlled' }}
                            color="primary"
                            id='isRemember'
                        />}
                        label="Recordarme"
                    /> */}
          <LoadingButton
            type="submit"
            fullWidth
            variant="contained"
            loading={loading}
            sx={{
              mt: 3,
              mb: 2,
              backgroundColor: BLUE_COLOR,
              color: WHITE_COLOR,
              '&:hover': {
                backgroundColor: BLUE_COLOR,
              },
            }}
          >
            ENTRAR
          </LoadingButton>
          {/*
        <Grid container>
            <Grid item xs>
                <Button
                    sx={{
                        mt: 0
                    }}
                    onClick={() => {
                        history.push('/recoverPassword')
                    }}
                >
                    Recuperar contraseña
                </Button>
            </Grid>
            <Grid item>
                <Link href="#" variant="body2">
                    {"Don't have an account? Sign Up"}
                </Link>
            </Grid> 
        </Grid>
        */}
        </Box>
      </Box>
      <Box>
        <CopyrightTemplate />
      </Box>
    </>
  );

  return (
    <ThemeProvider theme={mdTheme}>
      <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={8}
          sx={{
            backgroundImage: `url(./img/login/${num}.jpg)`,
            backgroundColor: (t) =>
              t.palette.mode === 'light'
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
        />
        <Grid
          item
          xs={12}
          sm={8}
          md={4}
          component={Paper}
          elevation={10}
          square
          style={{
            backgroundImage: `url(${splash})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: '50% 50%',
          }}
        >
          {form}
        </Grid>
      </Grid>
    </ThemeProvider>
  );
};

export default LoginModule;
